import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Observable } from 'rxjs';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';
import { MatDialog } from '@angular/material/dialog';
import { CodeSnippetEditDialogComponent } from './code-snippet-edit-dialog/code-snippet-edit-dialog.component';

@Component({
    selector: 'app-package-editor-ibextouch',
    templateUrl: './package-editor-ibextouch.component.html',
    styleUrls: ['./package-editor-ibextouch.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class PackageEditorIbextouchComponent implements OnInit, OnDestroy {

  public packageId;
  public myPackage: Models.Package;

  public messages;

  @Input() onSave: Observable<any>;
  public submitRequest = false;
  public availableLanguages;
  public generalFieldNames = ['enabled', 'isPortrait', 'isSearchEnabled', 'isSingleAppUsage', 'disableHelps', 'enableWheelchairNavigation', 'enableHighContrastMode', 'disableWidgetSubtitle', 'useGhosthand', 'showOnlyOneEntry', 'autoplayInterval',
    'fallbackInterval', 'screensaverTimeout', 'backgroundChangeInterval', 'launcherType', 'translationOverwrites', 'hideLegal', 'overwritePreviewLink', 'enableVideoSound', 'additionalGlobalConfig'];
  public styleFieldNames = ['navigation', 'navigationText', 'cardColor', 'cardOpacity', 'cardBlur', 'cardCorners', 'contentText', 'buttonColor', 'buttonOpacity',
    'barrierfreeBackgroundColor', 'barrierfreeTextColor', 'disableBlurInApp', 'bottomShadow', 'bottomShadowOpacity', 'logoPosition', 'customCss'];
  private subscription: any;

  constructor(private route: ActivatedRoute, private snackbar: SnackbarService, private packageService: PackageService, private ts: TranslateService, private dialog: MatDialog) {
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.route.snapshot.params['id'];
    this.subscription = this.onSave.subscribe(type => {
      if (type === 'ibextouch-reload') {
        this.initPackage();
      } else if (type === 'ibextouch') {
        this.save();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  public async save() {
    await this.packageService.update(this.myPackage._id, this.myPackage);
    this.submitRequest = false;
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  public async editCodeSnippet(snippetName: string) {
    const dialogRef = this.dialog.open(CodeSnippetEditDialogComponent, { width: '99vw', maxHeight: '95vh', data: snippetName });
    await dialogRef.afterClosed().toPromise();
  }

  private async initPackage() {
    const myPackage = await this.packageService.get(this.packageId);
    this.myPackage = myPackage;
    this.availableLanguages = myPackage.availableLanguagesCached;

    if (!this.myPackage.ibexTouch) {
      this.myPackage.ibexTouch = new Models.PackageIbexTouch();
    }
  }
}
